import {INITIAL_ZOOM, DEFAULT_ZOOM} from '../constants/map';

let dataLayer = window.dataLayer = window.dataLayer || [];

export function trackMapSearch(searchValue) {
    dataLayer.push({
        mapSearchTerm: searchValue,
        event: 'mapSearch'
    });
}

export function trackMapFilterSelect(filterValue) {
    dataLayer.push({
        mapFilterTerm: filterValue,
        event: 'mapFilterSelect'
    });
}

export function trackMapFindClosest() {
    dataLayer.push({
        event: 'MapFindClosest'
    });
}

export function trackLocationListMarkerClick(marker) {
    const { machineIds, address } = parseMarker(marker);
    dataLayer.push({
        machineId: machineIds,
        machineAddress: address,
        event: 'mapLocationListClick'
    });
}

export function trackMapMarkerClick(marker) {
    const {machineIds, address} = parseMarker(marker);
    dataLayer.push({
        machineId: machineIds,
        machineAddress: address,
        event: 'mapMarkerClick'
    });
}

let initialZoomCompleted = false;
export function trackMapZoomChange(currZoomLevel, newZoomLevel) {
    if (typeof currZoomLevel === 'undefined' || currZoomLevel === newZoomLevel) {
        return;
    }

    // hacky way to avoid tracking the initial map zoom

    // handle case where user loc available
    if (!initialZoomCompleted &&
        currZoomLevel === INITIAL_ZOOM && newZoomLevel === DEFAULT_ZOOM) {
        initialZoomCompleted = true;
        return;
    }

    // handle case where user loc not available
    if (!initialZoomCompleted && currZoomLevel === INITIAL_ZOOM) {
        initialZoomCompleted = true;
    }

    if (initialZoomCompleted) {
        const zoomAction = currZoomLevel - newZoomLevel < 0
            ? 'zoomed in'
            : 'zoomed out';

        dataLayer.push({
            mapZoomChange: zoomAction,
            event: 'mapZoomChange'
        });
    }
}

export function trackMapTypeSelect(mapType) {
    dataLayer.push({
        mapType,
        event: 'mapTypeSelect'
    });
}

// helpers

const parseMarker = (marker) => ({
    machineIds: marker.machines
        .map(m => m.machine_id)
        .join(', '),

    address: marker.address1
        + (marker.address2
            ? `, ${marker.address2}, `
            : ', ')
        + marker.city
});

